<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加门店-->
      <div class="common-form">新增问题</div>
      <el-form-item label="问题 " prop="problem_title" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.problem_title" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="答案 " prop="problem_content" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.problem_content" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="类型 " prop="problem_type" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.problem_type" class="max-w460"></el-input>
        <div class="tips">问题类型（1常见问题，2、支付问题，3、设备维修，4、租赁保障）</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>


    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  export default {
    data() {
      return {
        loading: false,
        /*form表单数据*/
        form: {
          problem_title: '',
          problem_content: '',
          problem_type:''
        },


      };
    },
    created() {},

    methods: {
      //提交表单
      onSubmit() {
        let self = this;
        let form = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.questionAdd(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                self.$router.push('/problem/problem/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/problem/problem/add.vue